import {
  TableCell,
  TableHead,
  TableRow,
}                from '@mui/material';
import { columnsType } from 'utils/type-utils';
import { FilterButton } from 'components/table/FilterButton';
import { SortingColumnTitle } from 'components/table/SortingColumnTitle';

const TableHeader = ({columns, filterable=false}) => (
  <TableHead>
    <TableRow>
      {columns.map((column, index) => (
        <TableCell key={index} {...column.cellProps} >
          <SortingColumnTitle column_key={column.key} column_name={column.headerName}/> {filterable && <FilterButton column={column.key} type={column.type}/>}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
)

TableHeader.propTypes = {
  columns: columnsType
};

export default TableHeader;

